import React from 'react';

import { CardWrapper } from './styles';

import target from '../../assets/illustrations/target.svg';
import stripe from '../../assets/illustrations/stripe_payments.svg';
import blog from '../../assets/illustrations/blog.svg';

import { VscSymbolKeyword } from 'react-icons/vsc';
import { MdHighQuality } from 'react-icons/md';
import { BiLinkAlt } from 'react-icons/bi';

function Card() {
    return (
        <CardWrapper>
            <div>
                <VscSymbolKeyword className="icon" size={60}/>
                <img src={blog} alt="" />
                <h1>Use keywords</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas dolore sunt quidem perspiciatis numquam ipsam culpa commodi quos deleniti laudantium.</p>
            </div>

            <div>
                <MdHighQuality className="icon" size={60}/>
                <img src={stripe} alt="" />
                <h1>High quality content</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas dolore sunt quidem perspiciatis numquam ipsam culpa commodi quos deleniti laudantium.</p>
            </div>

            <div>
                <BiLinkAlt className="icon" size={60}/>
                <img src={target} alt="" />
                <h1>Diversify your links</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas dolore sunt quidem perspiciatis numquam ipsam culpa commodi quos deleniti laudantium.</p>
            </div>
        </CardWrapper>
    );
}

export default Card;